"use client";
import { jsxs as S, jsx as t } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import "../../utils/cn.js";
import v from "../spinner/Spinner.js";
import { useButton as w } from "./useButton.js";
const N = h(
  (c, d) => {
    const {
      Component: m,
      children: l,
      spinnerPlacement: e,
      startContent: o,
      spinnerSize: u,
      spinner: r = /* @__PURE__ */ t(v, { color: "current", size: u }),
      endContent: s,
      loading: n,
      centerText: i,
      // disableRipple,
      getButtonProps: f,
      // getRippleProps,
      isIconOnly: C
    } = w({ ...c, ref: d }), a = n && e === "start" && r, p = n && e === "end" && r, x = i && (s || p) && /* @__PURE__ */ t("div", { className: "w-6" }), B = i && (o || a) && /* @__PURE__ */ t("div", { className: "w-6" });
    return /* @__PURE__ */ S(m, { ...f(), children: [
      a || o || x,
      n && C ? null : /* @__PURE__ */ t("div", { "data-children": !0, children: l }),
      p || s || B
    ] });
  }
);
N.displayName = "Button";
export {
  N as default
};
